import { useLocation, Link, useNavigate } from "react-router-dom";
import { FaRegUser } from "react-icons/fa";
import { TbTruckDelivery } from "react-icons/tb";
import { FaRegHeart } from "react-icons/fa";
import { LuClipboard } from "react-icons/lu";

const Options = [
  {
    title: "My Profile",
    link: "/profile",
    icon: FaRegUser,
  },
  {
    title: "Order Management",
    link: "/order",
    icon: TbTruckDelivery,
  },
  {
    title: "My Reviews",
    link: "/reviews",
    icon: LuClipboard,
  },
  {
    title: "My Wishlist",
    link: "/favorite",
    icon: FaRegHeart,
  },
];

const SideNavBar = () => {
  const pathName = useLocation().pathname;

  console.log(pathName);
  const navigate = useNavigate();
  return (
    <div className="w-52 py-3 flex gap-2 flex-col transtion-all border-[1px] bg-white rounded-md">
      {Options.map((option) => (
        <div key={option.title} className={`flex transition-all flex-col justify-center h-full min-h-10 ${(option?.link === pathName || pathName?.includes(option?.link)) && 'border-l-2 border-t-0  bg-[#05a30d34] border-l-[#05A30D] border-solid'}`}>
          <div
            onClick={() => navigate(option.link)}
            className={`text-sm flex pl-3 h-full transition-all gap-2 items-center ${
              (option?.link === pathName || pathName?.includes(option?.link)) &&
              "text-[#05A30D]"
            }`}
          >
            <div ></div>
            {option.link ? (
              <Link to={option.link} className="hover:text-[#05A30D]">
                {option.title}
              </Link>
            ) : (
              option.title
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SideNavBar;
